export const BundleMachineDelays = {
  PRODUCT_REPORT_TIMEOUT: 20_000,
  ADDED_CONFIRMATION_DURATION: 600,
};
